﻿import { IInputScope, KbInput } from "@app/components/kb-input/kb-input.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { Utils } from "@tools";

interface ICheckboxScope extends IInputScope {
    inputId?: string;
}
    
/**
 * KbCheckbox
 *
 * pass in an inputId to explicitly set the checkbox input with an id,
 * otherwise if its in a kbfield will use a guid that was generated by the kbField
 * if there is no ngModel and no id provided, it will create it's own guid
 */
@NgComponent({
    token: Token.KbCheckbox,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbCheckbox extends KbInput {
    constructor($timeout: ng.ITimeoutService) {
        super($timeout);
        this.scope = Utils.extend(this.scope, {
            inputId: "=?"
        });
        this.template = Dirs.component("kb-checkbox");

        this.link = (scope: ICheckboxScope, element: JQuery, atts: any, controllers: any[]) => {
            this.kbInputLinkFn(scope, element, atts, controllers);
            let ngModel = controllers[0];
            let kbField = controllers.length > 1 ? controllers[1] : null;

            if (atts.inputId) {
                // do nothing, use the inputid as is
            } else if (kbField && atts.ngModel) {
                // if we're inside a kbfield, then tie the labels together with the same id                
                scope.inputId = Utils.shortId();
                if (!scope.ignoreField) {
                    kbField.scope.isCheckbox = true;
                    kbField.scope._checkboxId = scope.inputId;
                }    
            } else {
                scope.inputId = Utils.shortId();
            }

            if (!scope.inputId) {
                throw new Error("empty checkbox id");
            }

            element.on("keydown", (e: JQueryEventObject) => {
                if (e.which == 13 || e.which == 32 && !scope.ngDisabled) {
                    scope.$apply(() => {
                        scope.ngModel = !scope.ngModel;
                        scope.ngChange();
                    });
                    e.preventDefault();
                }
                else if (e.which == 27) {
                    element.blur();
                }
            });

            scope.$on("$destroy", () => {
                element.off();
            });
        };
    }
}
